'use client';

import Link from '@alltrails/denali/components/Link';
import type TrailDetails from '@alltrails/types/TrailDetails';

type ParentTrailLinkProps = {
  parentTrail: NonNullable<TrailDetails['parentTrails']>[number];
};

const ParentTrailLink = ({ parentTrail }: ParentTrailLinkProps) => {
  return (
    <Link href={`/trail/${parentTrail.slug}`} target="_blank">
      {parentTrail.name}
    </Link>
  );
};

export default ParentTrailLink;
